var render = function render(_c,_vm){return _c('div',{class:_vm.$style.block},[_c('div',{class:[_vm.$style.blockHeader, _vm.props.headerClass]},[_c('h4',{class:_vm.$style.blockTitle},[_vm._v(_vm._s(_vm.props.title))]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_vm._t("header-right")],2)]),_vm._v(" "),_c('div',{class:_vm.$style.blockBody},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }